<template>
  <ApplicationBudget
    :contact-number="contactNumber"
    :finance-loading="financeLoading"
    :disable="
      isExistingQuoteOpen || !hasAccessAfterCalculator || financeLoading
    "
    :calculation-frequency="calculationFrequency"
    :continue-label="continueLabel"
    :budgets="budgets"
    :novated="quickQuote.novated"
    :summary-calculations="quickQuote.calculation"
    :take-home="quickQuote.takeHome"
    :lease-term="customerOptions.leaseTerm"
    :kms-per-year="customerOptions.kmsPerYear"
    :business-use="customerOptions.businessUse"
    :budget-comparison-view="budgetComparisonView"
    :budget-lease-type-view="budgetLeaseTypeView"
    :application-saving="applicationSaving"
    :calculator-assumptions-href="calculatorAssumptionsHref"
    @update:budget-comparison="setBudgetComparisonView"
    @update:budget-lease-type="setBudgetLeaseTypeView"
    @update:frequency="calculationFrequency = $event"
    @update:business-use="updateBusinessUse"
    @update:costs="updateCostsWeekly"
    @continue="budgetContinue"
  />
</template>

<script>
/* eslint-disable */
import { convertToFrequency } from '@/utils/payment-frequency-converter';
import { getEnv, getTheme } from 'ecx.saigon.ui.common';
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
import scrollToTop from '../../utils/scroll-to-top';

export default {
  name: 'BudgetWidget',
  metaInfo: {
    title: 'Budget |',
  },
  data() {
    return {
      updateApplicationPaths: this.$Constants.APPLICATION_UPDATE_PATHS.budget,
      budgetImage: undefined,
      calculatorAssumptionsHref: undefined,
      calculationFrequency:
        this.$Constants.CALCULATION_FREQUENCIES.monthly.value,
    };
  },
  computed: {
    ...mapState({
      financeLoading: (state) => state.application.financeLoading,
      quickQuote: (state) => state.application.quickQuote || {},
      costsWeekly: (state) =>
        state.application.application.metaData.costsWeekly,
      customerOptions: (state) =>
        state.application.application.metaData.customerOptions,
      applicationSaving: (state) => state.application.applicationSaving,
      budgetComparisonView: (state) => state.ui.budgetComparisonView,
      budgetLeaseTypeView: (state) => state.ui.budgetLeaseTypeView,
      user: (state) => state.user.user,
    }),
    ...mapGetters('application', ['isApplicationStarted']),
    ...mapGetters('quote', ['isExistingQuoteOpen']),
    ...mapGetters('user', ['hasAccessAfterCalculator']),
    contactNumber() {
      return getTheme(this.user.entity).support.phone;
    },
    continueLabel() {
      return this.isApplicationStarted
        ? 'Continue'
        : "I'm ready to choose my car";
    },
    budgets() {
      return [
        {
          type: 'fuel',
          label: 'Fuel',
          information: 'Fuel is based on car manufacturer’s estimate.',
          icon: 'icon-budget-fuel',
          value: this.costsWeekly.fuel,
        },
        {
          type: 'maintenance',
          label: 'Maintenance',
          information:
            'Maintenance is based on the car manufacturer’s estimate.',
          icon: 'icon-budget-maintenance',
          value: this.costsWeekly.maintenance,
        },
        {
          type: 'tyres',
          label: 'Tyres',
          information:
            'Tyres are based on the car manufacturer’s estimate, the length of your lease and your kilometre usage.',
          icon: 'icon-budget-tyres',
          value: this.costsWeekly.tyres,
        },
        {
          type: 'registration',
          label: 'Registration',
          information:
            'The registration cost is as per the statutory rates based on the postcode entered.',
          icon: 'icon-budget-registration',
          value: this.costsWeekly.registration,
        },
        {
          type: 'insurance',
          label: 'Comprehensive Insurance',
          information:
            'Insurance is estimated based on your car specifications and the postcode you entered.',
          icon: 'icon-budget-insurance',
          value: this.costsWeekly.insurance,
        },
      ];
    },
  },
  methods: {
    ...mapActions('application', ['updateApplication', 'getBudgetData']),
    ...mapMutations('application', [
      'setCostsWeekly',
      'updateCustomerOption',
      'setLeaseId',
    ]),
    ...mapMutations('ui', [
      'setBudgetComparisonView',
      'setBudgetLeaseTypeView',
    ]),
    updateBusinessUse(updateValue) {
      const initialValue = this.customerOptions.businessUse;
      this.updateCustomerOption({ field: 'businessUse', value: updateValue });
      const acknowledgement = this.$Constants.BUSINESS_USE_ACKNOWLEDGMENT_VALUE;

      if (initialValue < acknowledgement && updateValue >= acknowledgement) {
        this.SAIDialog({
          body: 'As your business use is greater than 50% a sales consultant will contact you to discuss your options',
          persistent: true,
          okText: 'Ok',
          cancelText: 'Cancel',
          onCancel: async () => {
            await this.updateCustomerOption({
              field: 'businessUse',
              value: initialValue,
            });
          },
        });
      }
    },
    async budgetContinue() {
      if (!this.isExistingQuoteOpen) {
        await this.updateApplication({
          updateApplicationPaths: this.updateApplicationPaths,
        });
      }

      await this.$router.push({
        name: this.$RouteNames.carSearch,
        params: { ...this.$router.currentRoute.params },
      });
    },
    updateCostsWeekly({ type, value }) {
      this.setCostsWeekly({
        ...this.costsWeekly,
        [type]: convertToFrequency(
          value,
          this.calculationFrequency,
          this.$Constants.CALCULATION_FREQUENCIES.monthly.value
        ),
      });
    },
  },
  async mounted() {
    scrollToTop(this.$el);
    const env = await getEnv();
    this.calculatorAssumptionsHref = env.VUE_APP_NOVATED_CALCULATOR_ASSUMPTIONS;

    if (this.$route.query.leaseId) {
      this.setLeaseId(this.$route.query.leaseId);
    }

    // await this.getBudgetData();
  },
  components: {
    ApplicationBudget: () => import('../../components/page/application-budget'),
  },
};
</script>
